import React = require("react");
import {ColorUtils} from "../components/Utils/color/ColorUtils";
import {DashboardConfigurationTexts, WidgetResponse} from "./DashboardContainer";
import {DashboardWidget} from "./widgets/DashboardWidget";

interface DashboardWidgetListProps {
    data: WidgetResponse[];
    configuration: DashboardConfigurationTexts;
    stackManager: any;
    colorGenerator: ColorUtils;
}

export class DashboardWidgetList extends React.Component<DashboardWidgetListProps> {

    constructor(props: DashboardWidgetListProps) {
        super(props);
    }

    public render() {
        if (!this.props) {
            return (
                // todo: handle when nothing is returned
                <div>Nothing Returned</div>
            );
        }

        const widgets = this.props.data.map((widget, index) => {
            return (
                <DashboardWidget
                    key={"DashboardWidget-" + index}
                    data={widget}
                    configuration={this.props.configuration}
                    stackManager={this.props.stackManager}
                    colorsUtils={this.props.colorGenerator}
                    hideOnLoading={widget.hideOnLoading}
                />
            );
        });

        return (widgets);
    }
}
